export enum ValidationModalSection {
  Builder = "Builder", // Default
  Workflow = "Workflow",
  Layout = "Layout",
  Settings = "Settings",
  Fields = "Fields",
  Definition = "Definition",
  PublicProfile = "Public Profile",
  Mapping = "Mapping",
  Properties = "Properties",
  Triggers = "Triggers",
  DefinitionsAndRoles = "Definitions and Roles",
  Configuration = "Configuration",
  Warning = "Warning",
  ValueMappings = "Value Mappings",
  DataPoints = "Data Points",
  DataSources = "Data Sources",
  Analytics = "Analytics",
  ListViews = "List Views",
  ProcessFlowVariable = "Variables",
  ProcessFlowStep = "Steps",
  Definitions = "Definitions"
}

export const validationModalSortOrder = [
  ValidationModalSection.DataSources,
  ValidationModalSection.DataPoints,
  ValidationModalSection.Builder,
  ValidationModalSection.Layout,
  ValidationModalSection.Mapping,
  ValidationModalSection.Properties,
  ValidationModalSection.Fields,
  ValidationModalSection.PublicProfile,
  ValidationModalSection.Definition,
  ValidationModalSection.Workflow,
  ValidationModalSection.Settings,
  ValidationModalSection.DefinitionsAndRoles,
  ValidationModalSection.Configuration,
  ValidationModalSection.Warning,
  ValidationModalSection.ValueMappings,
  ValidationModalSection.Triggers,
  ValidationModalSection.Analytics,
  ValidationModalSection.ListViews,
  ValidationModalSection.Definitions
]